export default "__VITE_ASSET__BbpBwuYA__"